module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.f4769f9bdb7466be6508.eot";


//////////////////
// WEBPACK FOOTER
// /home/markush/Projects/fieldsale-wingman-client/src/fonts/glyphicons-halflings-regular.eot
// module id = ../../../../../src/fonts/glyphicons-halflings-regular.eot
// module chunks = styles